import { useApp } from '../context/AppContext';
import { PageHeader } from '../components/ui/PageHeader';
import { CardBody } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
import { Check } from 'lucide-react';

export function TeacherClassPicker({ onNavigate }) {
  const { labels, teacherClasses, strengthForm, selectTeacherClass } = useApp();
  const activeId = strengthForm.class_id;

  return (
    <div className="space-y-4">
      <PageHeader
        title={labels.teacherSwitchClassTitle}
        subtitle={labels.teacherSwitchClassSubtitle}
      />

      <div className="space-y-2">
        {teacherClasses.map((cls) => {
          const isActive = String(cls.id) === String(activeId);
          return (
            <button
              key={cls.id}
              type="button"
              onClick={() => {
                selectTeacherClass(cls.id);
                onNavigate?.('home');
              }}
              className={`w-full rounded-xl border text-left transition-colors ${
                isActive
                  ? 'border-primary bg-primary-light shadow-card'
                  : 'border-border bg-card hover:bg-surface'
              }`}
            >
              <CardBody className="flex items-center justify-between gap-3 py-4">
                <div className="min-w-0">
                  <p className="font-semibold text-text">{cls.division_name}</p>
                  <p className="text-sm text-muted mt-0.5">
                    {labels.boys}: {cls.boys ?? 0} · {labels.girls}: {cls.girls ?? 0}
                    {(cls.max_boys > 0 || cls.max_girls > 0)
                      ? ` · ${labels.maxBoys}: ${cls.max_boys ?? 0} · ${labels.maxGirls}: ${cls.max_girls ?? 0}`
                      : cls.max_students
                        ? ` · ${labels.maxStudents}: ${cls.max_students}`
                        : ''}
                  </p>
                </div>
                {isActive ? (
                  <Badge variant="primary" className="shrink-0 gap-1">
                    <Check className="h-3.5 w-3.5" />
                    {labels.activeClass}
                  </Badge>
                ) : (
                  <span className="text-sm font-medium text-primary shrink-0">
                    {labels.selectClass}
                  </span>
                )}
              </CardBody>
            </button>
          );
        })}
      </div>
    </div>
  );
}
